import { render, staticRenderFns } from "./IMPeriod.vue?vue&type=template&id=a49f7b98&"
import script from "./IMPeriod.vue?vue&type=script&lang=js&"
export * from "./IMPeriod.vue?vue&type=script&lang=js&"
import style0 from "./IMPeriod.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports